<template>
  <Popup :open="open" :width="500" :position="{ top: 45, left: 0 }" :z-index="10">
    <div class="popup">
      <!-- loading true时 或 两个数组全部空时 展示loading -->
      <!-- 两个数组全部空时 且 loading false，键入或退格时会白屏，所以需要loading -->
      <div class="loading" v-if="isLoading || (relatedPopularSearch.length === 0 && relatedCompanies.length === 0)">
        <i class="iconfont icon-spinner"></i>
      </div>
      <template v-else>
        <template v-if="relatedPopularSearch.length">
          <div class="title">
            <div class="left">相关热搜</div>
            <div class="right"></div>
          </div>
          <div
            class="cell"
            :key="key + '_popular'"
            v-for="(item, key) in relatedPopularSearch"
            @click="handleRelatedPopularClick(item, key)"
            :style="{
              marginBottom: key === relatedPopularSearch.length - 1 && '6px',
            }"
          >
            <span v-html="item.subscribeWordHighLight"></span>
          </div>
        </template>
        <template v-if="relatedCompanies.length">
          <div class="title">
            <div class="left">相关公司</div>
            <div class="right" @click="handleMoreCompanyClick" v-if="relatedCompanyCount > 1">
              更多 {{ relatedCompanyCount }} 家公司 >
            </div>
          </div>
          <div
            class="cell"
            :key="key + '_company'"
            v-for="(item, key) in relatedCompanies"
            @click="handleRelatedCompaniesClick(item, key)"
            :style="{
              marginBottom: key === relatedCompanies.length - 1 && '6px',
            }"
          >
            <div class="cell_left">
              <div class="company_tag" :class="'company-tag-color' + ((key % 4) + 1)">
                {{ item.companyName[0] }}
              </div>
              <span class="text" v-html="item.showCompanyName"></span>
            </div>
          </div>
        </template>
      </template>
    </div>
  </Popup>
</template>

<script>
import Popup from "@/components/common/Popup";
import { websiteAssociationalSearch, websiteSearchSolrCompany } from "@/services/common/search";
import _ from "lodash";
const debounce = _.debounce((params, func) => {
  func(params);
}, 500);

export default {
  name: "PopupPopularSearch",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    keywordsLocal: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      relatedPopularSearch: [],
      relatedCompanies: [],
      relatedCompanyCount: "",
      isLoading: false,
    };
  },
  components: { Popup },
  watch: {
    keywordsLocal(keywordsLocal) {
      if (keywordsLocal) {
        debounce({}, async () => {
          this.isLoading = true;
          const res = await websiteAssociationalSearch({
            keyWord: keywordsLocal,
            fetchCount: 5,
          });
          this.relatedPopularSearch = res.data || [];
          const resCompany = await websiteSearchSolrCompany({
            keyword: keywordsLocal,
          });
          this.relatedCompanies = resCompany.data.data || [];
          this.relatedCompanyCount = resCompany.data.rowCount || "";
          this.isLoading = false;
          this.$emit("fetched", {
            relatedPopularSearch: this.relatedPopularSearch,
            relatedCompanies: this.relatedCompanies,
          });
        });
      }
    },
  },
  methods: {
    // 相关热搜 公司 点击
    handleRelatedPopularClick(value, index) {
      this.$emit("popular", { value, index });
    },
    handleRelatedCompaniesClick(value, index) {
      this.$emit("company", { value, index });
    },
    handleMoreCompanyClick() {
      this.$emit("more");
    },
  },
};
</script>
<style scoped lang="scss" src="./popular&history.scss" />
